export default __webpack_public_path__ + "static/Corprate_CareersMB-Header_03-6d622b6d81041e98e9f8e614d78828f3.jpg";